import Cookie from "js-cookie";

export default class AnnouncementBar {
    constructor() {
        this.selector = ".b-announcement-bar";

        this.selectors = {
            adminBar: "wpadminbar",
            close: ".b-announcement-bar__close",
            barTop: ".b-announcement-bar--top",
            root: "html",
            header: "header",
        };

        this.className = {
            hasBar: "document-has-bar",
            barTop: "b-announcement-bar--top",
            barHidden: "b-announcement-bar--hidden",
        };

        this.nodes = {};
    }

    bootstrap() {
        this.getNodes();
        this.handleBars();
        this.initHeaderTopPositionWithBar();
        window.addEventListener("load", this.resizeScrollLoad.bind(this));
        window.addEventListener("resize", this.resizeScrollLoad.bind(this));
        window.addEventListener("scroll", this.resizeScrollLoad.bind(this));
    }

    getNodes() {
        this.nodes = {
            bars: document.querySelectorAll(this.selector),
            adminBar: document.querySelector("#wpadminbar"),
            root: document.querySelector(this.selectors.root),
            header: document.querySelector(this.selectors.header),
            barTop: document.querySelector(this.selectors.barTop),
        };
    }

    resizeScrollLoad() {
        const { bars } = this.nodes;

        for (const bar of bars) {
            bar.style.transform = "translateY(0)";
        }

        this.handleRootClasses();

        this.topBarPosition({
            bar: document.querySelector(this.selectors.barTop),
        });

        this.handleHeaderTopPositionWithBar();
    }

    topBarPosition({ bar }) {
        if (!bar) {
            return;
        }

        const offset = this.getAdminBarHeight({
            node: this.nodes.adminBar,
        });

        if (bar.classList.contains(this.className.barTop)) {
            // eslint-disable-next-line no-param-reassign
            bar.style.top = `${offset}px`;
        }
    }

    handleBars() {
        const { bars } = this.nodes;

        if (bars.length === 0) {
            return;
        }

        for (const bar of bars) {
            const close1 = bar.querySelector(this.selectors.close);
            const TIMEOUT = 500;

            if (close1) {
                close1.addEventListener("click", (event) => {
                    event.preventDefault();
                    bar.classList.add(this.className.barHidden);
                    Cookie.set(bar.dataset.barId, true, {
                        expires: 7,
                    });

                    this.handleRootClasses();

                    setTimeout(() => {
                        jQuery(window).trigger("announcement-bar-hiding");
                    }, TIMEOUT);
                });
            }
        }
    }

    handleRootClasses() {
        const barTop = document.querySelector(this.selectors.barTop);

        const { root } = this.nodes;

        if (!barTop) {
            return;
        }

        if (barTop.classList.contains(this.className.barHidden)) {
            root.classList.remove(this.className.hasBar);
        } else {
            root.classList.add(this.className.hasBar);
        }
    }

    initHeaderTopPositionWithBar() {
        const { barTop } = this.nodes;

        if (!barTop) {
            return;
        }

        jQuery(window).on("announcement-bar-hiding", () => {
            this.handleHeaderTopPositionWithBar();
        });
    }

    handleHeaderTopPositionWithBar() {
        const { barTop, header, adminBar } = this.nodes;
        const { barHidden } = this.className;

        let headerOffsetFromBar = 0;

        if (!barTop) {
            return;
        }

        headerOffsetFromBar = barTop.classList.contains(barHidden)
            ? this.getAdminBarHeight({ node: adminBar })
            : barTop.offsetHeight + this.getAdminBarHeight({ node: adminBar });

        header.style.top = `${headerOffsetFromBar}px`;
    }

    getAdminBarHeight({ node }) {
        let nodeHeight = 0;

        if (!node) {
            return nodeHeight;
        }

        const styles = getComputedStyle(node);

        if (styles.position === "fixed") {
            nodeHeight = node.offsetHeight;
        }

        if (
            styles.position === "absolute" &&
            window.scrollY <= node.offsetHeight
        ) {
            nodeHeight = node.offsetHeight;
        }

        return nodeHeight;
    }
}
